var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ dashboard__data: !_vm.report }},[(_vm.report)?[_vm._v(" Потрачено звезд: "+_vm._s(_vm._f("roundTo2")(_vm.spendBonusSum))+" ")]:[_c('app-dashboard-num',{attrs:{"number":_vm.spendBonusSum ? _vm.spendBonusSum : 0,"comma":true,"arrow":"bot","icon":"star-icon","color":"#9E9E9E"}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }